import { computed } from 'vue';
import { useAuthStore } from '@/stores/authStore';

/**
 * The signed-in user as the account menu (NavUser) shows them: name, email,
 * whether they are a developer, and their initials for the avatar.
 */
export function useNavUser() {
    const authStore = useAuthStore();
    return computed(() => {
        const name = authStore.userData?.name ?? '';
        return {
            name,
            email: authStore.userData?.email,
            is_developer: authStore.userData?.is_developer,
            initials: name
                .split(' ')
                .map((part) => part.charAt(0))
                .join(''),
        };
    });
}
